import { KycComponent } from './front/kyc/kyc.component';
import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { componentFactoryName } from '@angular/compiler';
import { HomeComponent } from './front/home/home.component';
//import { QuestionsModule } from './questionary/questions/questions.module';
//import { AuthSigninModule } from './authentication/auth-signin/auth-signin.module';


const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./front/front-layout.module').then(m => m.FrontLayoutModule)
  },


  { path: 'auth/login', loadChildren: () => import('./authentication/auth-signin/auth-signin.module').then(m => m.AuthSigninModule) },
  { path: 'auth/signup', loadChildren: () => import('./authentication/auth-signup/auth-signup.module').then(m => m.AuthSignupModule) },
  //{ path: 'ques/questions', loadChildren: './questionary/questions/questions.module#QuestionsModule'}, 
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  // {
  //   path: '',
  //   redirectTo: 'admin/dashboard',
  //   pathMatch: 'full',
  // },
  //  {
  //   path: 'auth',
  //   children: [{
  //     path: '',
  //     loadChildren: './authentication/authentication.module#AuthenticationModule'
  //   }]
  // },
  // {
  //   path: 'admin',
  // //  canActivate: [AuthGuardService],
  //   component: AdminLayoutComponent,
  //   children: [{
  //     path: '',
  //     loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
  //   }]
  // },
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,
      { scrollPositionRestoration: 'enabled', preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' }
    )
  ],
  exports: [RouterModule
  ],
})
export class AppRoutingModule { }
